import React, { Component, PropTypes } from 'react';
import ReactSparkTextInput from '../../widgets/ReactSparkTextInput';
import { LinkIcon } from '../../assets/LinkIcon';
import { SparkTabs } from '../../ui/spark';
import { camelCaseToTitleCase } from '../../helpers/camelCaseToTitleConverter';
import Pagination from '../../helpers/Pagination';
import { head } from 'lodash';

// Label keys that must always render as read-only, regardless of the isDisabled prop.
const READ_ONLY_LABEL_KEYS = ['cfar.title.cancelForAnyReason'];

export default class LabelList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentPage: 1,
            inContextCurrentPage: 1,
            pageSize: 50,
            totalElements: 100,
            selectedTab: props.inContextLabelsOnly ? "inContext" : "hosted"
        };
        this.showPage = this.showPage.bind(this);
    }

    isLabelReadOnly(key) {
        return this.props.isDisabled || READ_ONLY_LABEL_KEYS.includes(key);
    }

    componentDidMount() {
        this.props.fetchLabels();
        this.tabsElm = new SparkTabs(this.tabsNode);
    }

    showPage(pageNo) {
        if(this.state.selectedTab === 'inContext') {
            this.setState({ inContextCurrentPage: pageNo });
        } else {
            this.setState({ currentPage: pageNo });
        }
    }
    setSelectedTab(tab) {
        this.setState({ selectedTab: tab });
    }
    render() {
        const start = (this.state.currentPage - 1) * this.state.pageSize;
        const end = start + this.state.pageSize;
        const inContextStart = (this.state.inContextCurrentPage - 1) * this.state.pageSize;
        const inContextEnd = inContextStart + this.state.pageSize;

        const { foldedValue, explicitValue } = this.props;
        const explicitKeys = explicitValue ? Object.keys(explicitValue) : null;
        const foldedValueArray = [];
        const inContextArray = [];

        Object.keys(foldedValue).forEach(key => {
            const obj = { [key]: foldedValue[key] };
            if (key.startsWith("shs-sbem") && this.props.inContextBeta) {
                inContextArray.push(obj);
            } else {
                foldedValueArray.push(obj);
            }
        });
        const elements = foldedValueArray.slice(start, end);
        const inContextElements = inContextArray.slice(inContextStart, inContextEnd);

        const totalElements = foldedValueArray.length;
        const inContextTotalElements = inContextArray.length;

        return (
            <div className="col-lg-12">
                <div ref={node => (this.tabsNode = node)} className="spark-tabs col-lg-12 col-xs-12 col-sm-6">
                    <nav className="spark-tabs__nav" role="menubar">
                        <div className="spark-tabs__scroll">
                            <ul className="spark-tabs__list" role="tablist">
                                {!this.props.inContextLabelsOnly &&
                                    <li className={`spark-tabs__tab text-center ${this.state.selectedTab === 'hosted' ? 'active' : ''}`} onClick={() => this.setSelectedTab('hosted')} aria-controls="hosted-tab" role="tab">
                                        <a>{this.props.inContextBeta ? 'Hosted' : 'General'}</a>
                                    </li>
                                }
                                {this.props.inContextBeta &&
                                    <li className={`spark-tabs__tab text-center ${this.state.selectedTab === 'inContext' || this.props.inContextLabelsOnly ? 'active' : ''}`} onClick={() => this.setSelectedTab('inContext')} aria-controls="incontext-tab" role="tab">
                                        <a>In-context</a>
                                    </li>
                                }
                                {/* <li className="spark-tabs__tab  text-center" role="tab"><a>Labels</a></li> */}
                            </ul>
                        </div>
                        <div className="spark-tabs__btns">
                            <button className="spark-tabs__btn spark-icon-arrow-chevron-left spark-tabs__btn--left" />
                            <button className="spark-tabs__btn spark-icon-arrow-chevron-right spark-tabs__btn--right" />
                        </div>
                    </nav>
                    <div className="spark-tabs__panels">
                        {!this.props.inContextLabelsOnly && (
                            <div role="tabpanel" className="spark-tabs__panel" id="hosted-tab">
                                {elements.map(elem => {
                                const explicitBoolean = explicitKeys
                                    ? explicitKeys.filter(e => {
                                          return e === Object.keys(elem)[0];
                                      })
                                    : [];
                                const readOnly = this.isLabelReadOnly(Object.keys(elem)[0]);
                                const length = explicitBoolean.length > 0;
                                const splitVariableName = Object.keys(elem)[0].split('.');
                                const splitVariableNameLength = splitVariableName.length;
                                const removePrefix = (str) => str.replace(/^Shs-sbem--/i, "");
                                const title = `${camelCaseToTitleCase(removePrefix(head(splitVariableName)))} ${removePrefix(camelCaseToTitleCase(
                                    splitVariableName[splitVariableNameLength - 2]
                                ))}: ${camelCaseToTitleCase(splitVariableName[splitVariableNameLength - 1])}`;
                                return (
                                    <div className="margin-top-bottom" key={Object.keys(elem)}>
                                        <h6 className="margin-heading">{title}</h6>
                                        <div className="row">
                                            <div className="col-lg-9">
                                                <ReactSparkTextInput
                                                    changeClass={length}
                                                    isDisabled={readOnly}
                                                    value={elem[Object.keys(elem)[0]]}
                                                    onChange={event => {
                                                        if (event.target.value === '') {
                                                            this.props.editLabels(Object.keys(elem)[0], ' ');
                                                        } else {
                                                            this.props.editLabels(
                                                                Object.keys(elem)[0],
                                                                event.target.value
                                                            );
                                                        }
                                                    }}
                                                />
                                            </div>
                                            <div className="col-lg-3 right-align-icons-labels row">
                                                {/* <LinkIcon disable={false} onClick={() => {}} iconType="spark-icon-trash"/> */}
                                                <div className="col-lg-6"></div>
                                                <div className="col-lg-3">
                                                    <LinkIcon
                                                        disable={readOnly}
                                                        onClick={() => {
                                                            this.props.editLabels(Object.keys(elem)[0], ' ');
                                                        }}
                                                        iconType="spark-icon-password-hide"
                                                    />
                                                </div>
                                                <div className="col-lg-3">
                                                    <LinkIcon
                                                        disable={readOnly}
                                                        onClick={() => {
                                                            this.props.clearLabels(Object.keys(elem)[0]);
                                                        }}
                                                        iconType="spark-icon-close"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                            <Pagination
                                onChange={this.showPage}
                                totalElements={totalElements}
                                currentPage={this.state.currentPage}
                                pageSize={this.state.pageSize}
                            />
                            </div>
                        )}
                        <div role="tabpanel" className="spark-tabs__panel" id="incontext-tab">
                            {inContextElements.map(elem => {
                                const explicitBoolean = explicitKeys
                                    ? explicitKeys.filter(e => {
                                          return e === Object.keys(elem)[0];
                                      })
                                    : [];
                                const readOnly = this.isLabelReadOnly(Object.keys(elem)[0]);
                                const length = explicitBoolean.length > 0;
                                const splitVariableName = Object.keys(elem)[0].split('.');
                                const splitVariableNameLength = splitVariableName.length;
                                const removePrefix = (str) => str.replace(/^Shs-sbem--/i, "");
                                const title = `${camelCaseToTitleCase(removePrefix(head(splitVariableName)))} ${removePrefix(camelCaseToTitleCase(
                                    splitVariableName[splitVariableNameLength - 2]
                                ))}: ${camelCaseToTitleCase(splitVariableName[splitVariableNameLength - 1])}`;
                                return (
                                    <div className="margin-top-bottom" key={Object.keys(elem)}>
                                        <h6 className="margin-heading">{title}</h6>
                                        <div className="row">
                                            <div className="col-lg-9">
                                                <ReactSparkTextInput
                                                    changeClass={length}
                                                    isDisabled={readOnly}
                                                    value={elem[Object.keys(elem)[0]]}
                                                    onChange={event => {
                                                        if (event.target.value === '') {
                                                            this.props.editLabels(Object.keys(elem)[0], ' ');
                                                        } else {
                                                            this.props.editLabels(
                                                                Object.keys(elem)[0],
                                                                event.target.value
                                                            );
                                                        }
                                                    }}
                                                />
                                            </div>
                                            <div className="col-lg-3 right-align-icons-labels row">
                                                {/* <LinkIcon disable={false} onClick={() => {}} iconType="spark-icon-trash"/> */}
                                                <div className="col-lg-6"></div>
                                                <div className="col-lg-3">
                                                    <LinkIcon
                                                        disable={readOnly}
                                                        onClick={() => {
                                                            this.props.editLabels(Object.keys(elem)[0], ' ');
                                                        }}
                                                        iconType="spark-icon-password-hide"
                                                    />
                                                </div>
                                                <div className="col-lg-3">
                                                    <LinkIcon
                                                        disable={readOnly}
                                                        onClick={() => {
                                                            this.props.clearLabels(Object.keys(elem)[0]);
                                                        }}
                                                        iconType="spark-icon-close"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                            <Pagination
                                onChange={this.showPage}
                                totalElements={inContextTotalElements}
                                currentPage={this.state.inContextCurrentPage}
                                pageSize={this.state.pageSize}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/labels/LabelList.js